'use client'

import React from 'react'
import Image from 'next/image'
import { Container, Flex } from '@quark/layout'
import { Text } from '@quark/typography'
import { Animations, MultiReveal, Reveal } from '@quark/animation'
import styles from './categories.module.scss'

const Categories = data => {
  const isType1 = data?.listType === 'type1'
  const titleFontStyle: {
    lg: 'um_text-5xl/bold' | 'um_text-5xl/normal'
    md: 'um_text-4xl/bold' | 'um_text-4xl/normal'
    sm: 'um_text-3xl/bold' | 'um_text-3xl/normal'
  } = isType1
    ? { lg: 'um_text-5xl/bold', md: 'um_text-4xl/bold', sm: 'um_text-3xl/bold' }
    : { lg: 'um_text-5xl/normal', md: 'um_text-4xl/normal', sm: 'um_text-3xl/normal' }

  return (
    <Container
      type="root"
      paddingTop={{ lg: 'spacing-72', md: 'spacing-56', sm: 'spacing-40' }}
      paddingBottom={{ lg: 'spacing-72', md: 'spacing-56', sm: 'spacing-40' }}
      paddingRight="spacing-16"
      paddingLeft="spacing-16">
      <Reveal as="span" animationProps={{ threshold: 0.1, animationDelayMs: 100 }}>
        <Container type="max-parent" paddingBottom={{ lg: 'spacing-64', md: 'spacing-56', sm: 'spacing-48' }}>
          <Text
            as="h1"
            fontStyle={titleFontStyle}
            color="base/primary"
            textAlign={{ lg: 'center', md: 'center', sm: 'center' }}>
            <span dangerouslySetInnerHTML={{ __html: data?.title || '' }} />
          </Text>
        </Container>
      </Reveal>
      <Reveal as="span" animationProps={{ threshold: 0.1, animationDelayMs: 200 }}>
        <MultiReveal
          as={Flex}
          flexDirection="row"
          gap={{
            lg: 'spacing-48',
            md: 'spacing-36',
            sm: 'spacing-24',
          }}
          flexWrap="wrap"
          justifyContent={{
            lg: 'space-between',
            md: 'space-between',
            sm: 'space-around',
          }}
          animationDelays={(i: number) => 300 + i * 100}
          animationProps={{ animation: Animations.FadeIn50px }}>
          {data?.categories?.map(category => (
            <div className={styles.categoryItem}>
              <Image
                src={category?.iconUrl?.url}
                alt={category?.title}
                width={148}
                height={148}
                className={`${styles.categoryImage} ${isType1 ? '' : styles.categoryItemType2}`}
              />
              <p className={styles.categoryTitle}>{category?.title}</p>
            </div>
          ))}
        </MultiReveal>
      </Reveal>
    </Container>
  )
}

export default Categories
